export default __webpack_public_path__ + "static/media/team-3.da4a2a0f.jpg";